/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class LineItemRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    return hash({
      item: this.store.findRecord('finance/line-item', params.lineitem_id),
      transactions: this.store.query('finance/transaction', {
        lineItemId: params.lineitem_id,
        include: 'sourceTransactions',
      }),
    });
  }

  resetController(controller) {
    controller.reset();
    return super.resetController(...arguments);
  }
}
